import { BASE_URL } from '@app/settings/base-url';
import { baseApi } from '@app/store/index.api';

import {
  ITokenSaleResponse,
  IRejectTokenSaleQuery,
  IRejectTokenSaleResponse,
  IApproveTokenSaleQuery,
  IApproveTokenSaleResponse,
  IDownloadDisputeFileQuery,
  ICreateTokenSaleQuery,
  ICreateTokenSaleResponse,
} from '../model/types';

const tokenSellApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getTokenSales: builder.query<ITokenSaleResponse, string>({
      query: query => {
        return {
          url: `pd/trader-orders?filter[type][]=sellToken&${query}`,
        };
      },
    }),
    rejectTokenSale: builder.mutation<IRejectTokenSaleResponse, IRejectTokenSaleQuery>({
      query: query => {
        return {
          url: `/pd/trader-orders/${query.id}/reject`,
          method: 'PATCH',
          body: query,
        };
      },
    }),
    approveTokenSale: builder.mutation<IApproveTokenSaleResponse, IApproveTokenSaleQuery>({
      query: query => {
        return {
          url: `/pd/trader-orders/${query.id}/approve`,
          method: 'PATCH',
          body: query,
        };
      },
    }),
    getDisputeFile: builder.query<Blob, IDownloadDisputeFileQuery>({
      query: query => {
        return {
          url: `${BASE_URL}/trader/order/${query.id}/dispute/download`,
          responseHandler: response => {
            return response.blob();
          },
        };
      },
    }),
    createTokenSale: builder.mutation<ICreateTokenSaleResponse, ICreateTokenSaleQuery>({
      query: ({ wallet_id, amount }) => {
        return {
          url: `/pd/trader-orders/${wallet_id}/create`,
          method: 'POST',
          body: { amount },
        };
      },
    }),
  }),
});

export const {
  useGetTokenSalesQuery,
  useRejectTokenSaleMutation,
  useApproveTokenSaleMutation,
  useLazyGetDisputeFileQuery,
  useCreateTokenSaleMutation,
} = tokenSellApi;
